// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rr1G","colMin":"styles_colMin__3RRgj"};